<template>
    <v-form :name="searchProps.formName"
            @keyup.enter="autoSearch = true">
        <TabView scrollable
                 style="overflow: visible"
                 :pt="{ panelContainer: { class: 'form-tab-panel' } }">
            <TabPanel :header="__('Search condition')"
                      headerClass="form-tab-header">
                <div class="grid">
                    <FormInputText fieldName="scale_name"
                                   label="Scale name"
                                   size="8"
                                   :isFocus="true"
                                   v-model:field="search.scale_name" />

                    <FormInputNumber fieldName="percent_from"
                                     label="Percentage value from"
                                     size="2"
                                     :min="0"
                                     :max="100"
                                     :minFractionDigits="0"
                                     :maxFractionDigits="0"
                                     v-model:field="search.percent_from" />

                    <FormInputNumber fieldName="percent_to"
                                     label="Percentage value to"
                                     size="2"
                                     :min="0"
                                     :max="100"
                                     :minFractionDigits="0"
                                     :maxFractionDigits="0"
                                     v-model:field="search.percent_to" />

                </div>
            </TabPanel>
        </TabView>


        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})

const autoSearch = ref(false)

let search = ref({})
prepareSearch(search, props)

// -----------------------------------------------------

</script>

<style lang="scss"
       scoped></style>
